/**
 * Choose a Kuutio instance's labels (#1209): one toggle per label in the
 * vocabulary, at least one required. Used by the create form, Perustiedot
 * and the row menu in Instanssit.
 */
import React from 'react';
import styled from '@emotion/styled';
import { INSTANCE_LABELS } from '../../../../../packages/shared/instanceLabels.js';
import { useTranslation } from '../../hooks/useTranslation.jsx';
import { LABEL_COLORS } from './LabelChips';

const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Toggle = styled.button`
  min-height: 32px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid ${p => (p.$on ? p.$color : 'rgba(255, 255, 255, 0.2)')};
  background: ${p => (p.$on ? `${p.$color}26` : 'transparent')};
  color: ${p => (p.$on ? p.$color : 'rgba(255, 255, 255, 0.7)')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) { filter: brightness(1.2); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const Hint = styled.small`
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

export default function LabelPicker({ value, onChange, disabled = false, hint = true }) {
  const { t } = useTranslation();
  const selected = Array.isArray(value) ? value : [];
  const toggle = (label) => {
    onChange(selected.includes(label) ? selected.filter((l) => l !== label) : [...selected, label]);
  };
  return (
    <div>
      <Group role="group" aria-label={t('instanceLabels.title')}>
        {INSTANCE_LABELS.map((label) => (
          <Toggle key={label} type="button" aria-pressed={selected.includes(label)}
            $on={selected.includes(label)} $color={LABEL_COLORS[label]}
            onClick={() => toggle(label)} disabled={disabled}
            title={t(`instanceLabels.${label}_hint`)}
          >
            {t(`instanceLabels.${label}`)}
          </Toggle>
        ))}
      </Group>
      {hint && <Hint>{t('instanceLabels.help')}</Hint>}
    </div>
  );
}
